module.exports = __webpack_public_path__ + "img/medical_cover.9ccf72bd.webp";